<div class="bg-light w-100">
  <form class="row gy-2 gx-3 align-items-center p-3 pt-2 mt-3">
    <div class="col">
      <label for="search" class="visually-hidden">Filter</label>
      <input id="search" [disabled]="loading" type="text" class="form-control me-2" (keyup)="applyFilter($event)" placeholder="Filter">
    </div>
    <div class="col-auto text-end">
      <button [routerLink]="getCreateLink()" type="button" class="btn btn-primary">
        <i class="fas fa-plus mouse-pointer"></i> {{createButtonLabel}}
      </button>
    </div>
  </form>
</div>

<ng-template #template let-idvaluechild="idvalue" let-entityroot="entityroot" let-elementinput="element">
  <app-crud-list-element-buttons [idvaluechild]="idvaluechild"
                       [entityroot]="entityroot"
                       [editable]="editable"
                       [removable]="removable"
                       [creatable]="creatable"
                       [readable]="readable"
                       [editPath]="getEditPath(idvaluechild)[0]"
                       [deleteEntityHandler]="deleteEntityHandler"
                       [removePostTreatmentHandler]="removePostTreatmentHandler"
  ></app-crud-list-element-buttons>
</ng-template>

<ng-template #standardColumnTemplate let-columninput="column" let-elementinput="element" let-valueinput="value">
  <div class="ms-2 me-2">
    <ng-container *ngIf="columninput.isKeyColumn">
      <a *ngIf="editable" [routerLink]="getEditPath( getIdColumnValue(elementinput) )">{{valueinput}}</a>
      <span *ngIf="!editable">{{valueinput}}</span>
    </ng-container>
    <ng-container *ngIf="!columninput.isKeyColumn">
      {{valueinput}}
    </ng-container>
  </div>
</ng-template>

<ng-template #activeTemplate let-valueinput="value">
  <div class="ms-2">
    <ng-container *ngIf="valueinput===true || valueinput===1">
        <i class="fas fa-circle limegreen"></i>
    </ng-container>
    <ng-container *ngIf="valueinput===false || valueinput===0">
        <i class="fas fa-circle red"></i>
    </ng-container>
  </div>
</ng-template>

<table mat-table [dataSource]="datalistsource" matSort>

  <ng-container *ngFor="let column of allDisplayedColumns">

    <ng-container matColumnDef="{{column.columnName}}">
      <th mat-header-cell class="pl-2 pr-2 thead-light" *matHeaderCellDef mat-sort-header>{{column.label}}</th>
      <td mat-cell *matCellDef="let element">
        <!-- default column display -->
        <ng-container *ngIf="!column.template">
          <ng-container *ngIf="column['columnName']!=='active'">
            <ng-container *ngTemplateOutlet="standardColumnTemplate; context: {
              column: column,
              element:element,
              value:element[column.columnName]}">
            </ng-container>
          </ng-container>
          <!-- active column display -->
          <ng-container *ngIf="column['columnName']==='active'">
            <ng-container *ngTemplateOutlet="activeTemplate; context: {
              value:element[column.columnName]
            }">
            </ng-container>
          </ng-container>
        </ng-container>
        <!-- custom column display -->
        <ng-container *ngIf="column.template">
          <ng-container *ngTemplateOutlet="column.template; context: {
              column: column,
              element:element,
              value:element[column.columnName],
              idvalue:getIdColumnValue(element)
            }">
          </ng-container>
        </ng-container>
      </td>
    </ng-container>

  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell class="pl-2 pr-2 text-capitalize thead-light" *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <ng-container *ngTemplateOutlet="template; context: {
          idvalue: getIdColumnValue(element), entityroot: entityroot
        }">
      </ng-container>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
  <tr mat-row *matRowDef="let row; columns: columnNames;"></tr>

</table>

<ng-container *ngIf="loading">
  <app-spinner></app-spinner>
</ng-container>

<mat-paginator [pageSizeOptions]="[20, 100, 500]" showFirstLastButtons></mat-paginator>
<div class="mb-5"></div>

